import type { MessageStatusVariant } from '@zg-rentals/satellite-components';

export enum ListingAvailability {
  Available = 'available',
  Offmarket = 'offmarket',
  Unknown = 'unknown',
}

export enum MessageTypes {
  NotAcceptingReplies = 'notAcceptingReplies',
  PhoneLead = 'phoneLead',
  ListingMessage = 'listingMessage',
  SystemMessage = 'systemMessage',
}

/**
 * Attachment shape used by MessageItem and AddMessage (zDocId casing for UI).
 */
export type ConversationMessageAttachment = {
  attachmentMetadataStatus?: string;
  downloadUrl?: string;
  fileName?: string;
  fileSizeBytes?: number;
  fileType?: string;
  isAttachmentDeleted?: boolean;
  isAttachmentExpired?: boolean;
  previewUrl?: string;
  zDocId?: string;
};

/**
 * Message shape used by MessageList/MessageItem. messageDateMs is string for display.
 */
export type ConversationMessage = {
  aiAutoResponseType?: string;
  attachments: Array<ConversationMessageAttachment>;
  conversationId?: string;
  isMessageOwner?: boolean;
  message?: string;
  messageDateMs: string;
  messageId?: string;
  messageType: string;
  senderName?: string;
  uiTreatmentType?: string;
  title?: string;
  messageLink?: { url?: string; text: string };
};

export type DecoratedMessage = ConversationMessage & {
  sendStatus?: MessageStatusVariant;
  temporaryMessageKey?: string;
};
